export default __webpack_public_path__ + "static/media/1.5f02e8af.gif";